import { createFileRoute } from '@tanstack/react-router';
import { TablesPage } from '@/features/table-ordering/pages/tables-page';

export const Route = createFileRoute('/_app/tables')({ component: TablesPage });
